<div class="kolaConfigurationPopupSec" id="kolaConfigPopupSec">
  <a (click)="closeDialog()" class="md-dialog-close waves-effect closebtncls"><i class="material-icons btn-floating btn-small waves-effect waves-light cross-icon-bg"></i></a>
  <div id="kolaConfigContentSec">
    <h2 md-dialog-title>System Configuration</h2>

    <!-- <ng-template #koalaDynamicFields></ng-template> -->
    <md-dialog-content>
      <form id="koalaForm" class="kolaConfigurationPopup" novalidate [formGroup]="koalaConfigForm">
        <div class="row">
          <div class="col s12 m12 l12">
          <ul #perfectScrollSection class="kolaConfigTbCls customScrollKoala">
            <li *ngFor="let groupIndex of KoalaItemGroupIndex;let i = index;">
              <div formGroupName="{{groupIndex}}">
                <div class="kolaFieldCls errorZoneSec">
                  <md-form-field class="example-full-width">
                    <input mdInput placeholder="Serial Number" formControlName="serialNo" maxlength="12">
                  </md-form-field>
                  <p requiredField *ngIf="koalaConfigForm.controls[groupIndex].controls.serialNo.touched && koalaConfigForm.controls[groupIndex].controls.serialNo.invalid"></p>
                </div>
                <div class="kolaFieldCls errorZoneSec">
                  <md-form-field class="example-full-width">
                    <input mdInput placeholder="Mac Address" formControlName="macAddress" maxlength="17" (keyup) = "onKeyup(groupIndex)" >
                  </md-form-field>
                  <p requiredField *ngIf="koalaConfigForm.controls[groupIndex].controls.macAddress.touched && koalaConfigForm.controls[groupIndex].controls.macAddress.errors && koalaConfigForm.controls[groupIndex].controls.macAddress.errors.required"></p>
                  <p class="validate" *ngIf="koalaConfigForm.controls[groupIndex].controls.macAddress.touched && koalaConfigForm.controls[groupIndex].controls.macAddress.errors && koalaConfigForm.controls[groupIndex].controls.macAddress.errors.pattern">Incorrect Mac Address</p>
                </div>
              </div>
              <div class="kolaAddDelBtn">
                <button md-icon-button [mdMenuTriggerFor]="menu">
                            <md-icon>more_vert</md-icon>
                       </button>
                <md-menu #menu="mdMenu">
                  <button md-menu-item (click)="onAdd(groupIndex, perfectScrollSection)">
                         <span>Add</span>
                         </button>
                  <button md-menu-item (click)="onDelete(groupIndex, perfectScrollSection)">
                         <span>Delete</span>
                         </button>
                </md-menu>
              </div>
            </li>

          </ul>
          </div>
          <div class="button-row">
            <button [disabled]="koalaConfigForm.invalid" md-raised-button class="glbAdminBtnCls1" (click)="requestKoala(perfectScrollSection)">REQUEST SYSTEM</button>
          </div>
        </div>
      </form>

      <!-- grid code -->
      <div class="cusPaginationContainer example-container mat-elevation-z8">
          <div *ngIf="countListItems == 0">
            <p class="nodataFound"> No Results Found</p>
          </div>
          <md-table class="kolaPopupTable" #table [dataSource]="dataSource" mdSort [ngClass]="{'hide-grid': countListItems == 0 }">

            <md-header-row *mdHeaderRowDef="displayedColumns"></md-header-row>

            <md-row *mdRowDef="let row; columns: displayedColumns;"></md-row>

            <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->

            <!-- as per ticket 972, removed Id Column -->
            <!-- <ng-container mdColumnDef="id">
            <md-header-cell *mdHeaderCellDef md-sort-header>#</md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.id}} </md-cell>
          </ng-container> -->


            <!-- Serial Number Column -->
            <ng-container mdColumnDef="serialNumber">
              <md-header-cell *mdHeaderCellDef md-sort-header>SERIAL NUMBER</md-header-cell>
              <md-cell *mdCellDef="let element"> {{element.serialNumber}} </md-cell>
            </ng-container>

            <!-- Mac address Column -->
            <ng-container mdColumnDef="macAddress">
              <md-header-cell *mdHeaderCellDef md-sort-header>MAC ADDRESS</md-header-cell>
              <md-cell *mdCellDef="let element"> {{element.macAddress}} </md-cell>
            </ng-container>

            <!-- Koala Id Column -->
            <ng-container mdColumnDef="koalaId">
              <md-header-cell *mdHeaderCellDef md-sort-header>SYSTEM ID</md-header-cell>
              <md-cell *mdCellDef="let element"> {{element.koalaId}} </md-cell>
            </ng-container>

            <!-- Koala Status Column -->
            <ng-container mdColumnDef="koalaStatus">
              <md-header-cell *mdHeaderCellDef md-sort-header>STATUS</md-header-cell>
              <md-cell *mdCellDef="let element"> {{element.koalaStatus}} </md-cell>
            </ng-container>

            <!-- Action  Column -->
            <ng-container mdColumnDef="action">
              <md-header-cell *mdHeaderCellDef>ACTIONS</md-header-cell>
              <md-cell *mdCellDef="let element">


                <ng-container *ngIf="element.koalaStatusCode.toLowerCase() == 'active'">
                  <a (click)="onChangeStatus(3, element.id)">Retire</a> <a (click)="onChangeStatus(4, element.id)">Unavailable</a>
                </ng-container>
                <ng-container *ngIf="element.koalaStatusCode.toLowerCase() == 'unavailable'">
                  <a (click)="onChangeStatus(3, element.id)">Retire</a> <a (click)="onChangeStatus(1, element.id)">Active</a>
                </ng-container>

              </md-cell>

            </ng-container>

          </md-table>

        </div>

      <!-- grid code end -->

    </md-dialog-content>
  </div>

</div>


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location/adm-manage-koalaconfig/adm-manage-koalaconfig.component.html